import {useNavigate} from 'react-router';

import {useCreateWholesalePositions} from '@/pages/(shared)/positions/new/providers/createWholesalePositionsProvider';

import Page from '@/components/Page';

/**
 * Wholesale positions details component
 * @returns {JSX.Element}
 */
function WholesalePositionsDetails() {
  const navigate = useNavigate();
  const {positions, acknowledged, setAcknowledged, setAcknowledging, totals, handleSubmitPositions, isSubmitting} =
    useCreateWholesalePositions();

  const handleSubmit = async () => {
    if (acknowledged) {
      await handleSubmitPositions();

      navigate('/speculator/positions');
    }
  };

  return (
    <Page
      currentPage="Review Positions"
      activePage="Review Positions"
      mainPage="Review Positions"
      handleBack={() => setAcknowledging(false)}
    >
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 xl:col-span-9">
          <div className="box">
            <div className="box-header block md:flex">
              <div className="bllock h5 mb-0 items-center sm:flex">
                <img className="w-10" src={'/images/logo/logo.png'} alt="" />
                <div className="ms-0 mt-2 sm:ms-2 sm:mt-0">
                  <div className="h6 mb-0 font-semibold">
                    POSITIONS REVIEW : <span className="text-primary">#8140-2099</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 xl:col-span-12">
                  <div className="table-responsive">
                    <table className="nowrap mt-4 table min-w-full whitespace-nowrap border dark:border-defaultborder/10">
                      <thead>
                        <tr>
                          <th scope="row" className="text-start">
                            Market
                          </th>
                          <th scope="row" className="text-start">
                            Brand
                          </th>
                          <th scope="row" className="text-start">
                            Product
                          </th>
                          <th scope="row" className="text-start">
                            Quantity
                          </th>
                          <th scope="row" className="text-start">
                            Wholesale
                          </th>
                          <th scope="row" className="text-start">
                            Markup
                          </th>
                          <th scope="row" className="text-start">
                            Retail
                          </th>
                          <th scope="row" className="text-start">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {positions.map((position, index) => (
                          <>
                            <tr key={index} className="border border-defaultborder dark:border-defaultborder/10">
                              {/* MARKET */}
                              <td>
                                <div className="font-semibold">
                                  {position.item.market?.market_name || 'Unknown Market'}
                                </div>
                              </td>
                              {/* BRAND */}
                              <td>
                                <div className="text-[#8c9097] dark:text-white/50">
                                  {position.item.brand?.brand_name || 'Unknown Brand'}
                                </div>
                              </td>
                              {/* PRODUCT */}
                              <td>
                                <div className="text-[#8c9097] dark:text-white/50">
                                  {position.item.product?.product_name || 'Unknown Product'}
                                </div>
                              </td>
                              {/* QUANTITY */}
                              <td className="product-quantity-container">{position.item.quantity}</td>
                              {/* WHOLESALE */}
                              <td>
                                $
                                {position.item.wholesale_price.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                              {/* MARKUP */}
                              <td>{position.item.markup}%</td>
                              {/* RETAIL*/}
                              <td>
                                $
                                {(
                                  position.item.quantity *
                                  position.item.wholesale_price *
                                  (1 + position.item.markup / 100)
                                ).toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                              {/* TOTAL which is the item.quantity * item.wholesale_price * (1 + item.markup) */}
                              <td>
                                $
                                {(position.item.wholesale_price * position.item.quantity).toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                            </tr>
                          </>
                        ))}
                        <tr className="border border-defaultborder dark:border-defaultborder/10">
                          <td colSpan={8} className="text-right">
                            <p className="mb-2 text-right">
                              <span className="mr-4">Sub Total :</span>
                              <span className="text-[.9375rem] font-semibold">
                                $
                                {totals.subtotal.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </p>

                            <p className="mb-0 text-right">
                              <span className="mr-4 text-[.875rem]">Total :</span>
                              <span className="text-[1rem] font-semibold text-success">
                                $
                                {totals.subtotal.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="box-footer flex flex-col items-start justify-between space-y-4 md:flex-row md:items-center md:space-y-0">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="terms"
                  className="mr-2"
                  checked={acknowledged}
                  onChange={e => setAcknowledged(e.target.checked)}
                />
                <label htmlFor="terms" className="text-sm">
                  I acknowledge and agree to the terms and conditions
                </label>
              </div>
              <div className="flex space-x-2">
                <button onClick={() => setAcknowledging(false)} type="button" className="ti-btn bg-danger text-white">
                  Cancel <i className="ri-close-line ms-1 align-middle"></i>
                </button>
                <button
                  type="button"
                  className={`ti-btn ${acknowledged && !isSubmitting ? 'bg-success text-white' : 'cursor-not-allowed bg-gray-400 text-gray-600'}`}
                  disabled={!acknowledged || isSubmitting}
                  onClick={handleSubmit}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'} <i className="ri-check-line ms-1 align-middle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 xl:col-span-3">
          <div className="box">
            <div className="box-header">
              <div className="box-title">Mode Of Payment</div>
            </div>
            <div className="box-body">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 xl:col-span-12">
                  <p className="mb-4 text-[.875rem] font-semibold">Credit/Debit Card</p>
                  <p className="mb-4">
                    <span className="text-[0.75rem] font-semibold text-[#8c9097] dark:text-white/50">
                      Name On Card :
                    </span>{' '}
                    Json Taylor
                  </p>
                  <p className="mb-4">
                    <span className="text-[0.75rem] font-semibold text-[#8c9097] dark:text-white/50">
                      Card Number :
                    </span>{' '}
                    1234 5678 9087 XXXX
                  </p>
                  <p className="mb-4">
                    <span className="text-[0.75rem] font-semibold text-[#8c9097] dark:text-white/50">
                      Total Amount :
                    </span>{' '}
                    <span className="text-[.875rem] font-semibold text-success">$2570.42</span>
                  </p>
                  <p className="mb-4">
                    <span className="text-[0.75rem] font-semibold text-[#8c9097] dark:text-white/50">Due Date :</span>{' '}
                    29,Dec 2022 - <span className="text-[0.75rem] font-semibold text-danger">30 days due</span>
                  </p>
                  <p className="mb-4">
                    <span className="text-[0.75rem] font-semibold text-[#8c9097] dark:text-white/50">
                      Invoice Status : <span className="badge bg-warning/10 text-warning">Pending</span>
                    </span>
                  </p>
                  <div className="alert alert-success" role="alert">
                    Please Make sure to pay the invoice bill within 30 days.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default WholesalePositionsDetails;
